/**
 * Video Services.
 *
 * @format
 */

/**
 * Load Video Script.
 */
export const loadVideoScript = (videoId: string, fullReload = false): void => {
  if ((!window.videojs && !window.bc) || fullReload) {
    const videoScript = document.createElement('script');
    videoScript.src =
      'https://players.brightcove.net/2418587696001/FoCKoQVZW_default/index.min.js';
    document.body.appendChild(videoScript);
  } else {
    window.bc(videoId);
  }
};

/**
 * Stop All Videos.
 */
export const stopAllVideos = (): void => {
  const allVideos: NodeListOf<Element> = document.querySelectorAll('.video-js');

  if (allVideos.length > 0) {
    Array.prototype.forEach.call(allVideos, (video: Element): void => {
      if (
        typeof window.videojs === 'function' &&
        video.id !== '' &&
        !video.classList.contains('background-video')
      ) {
        window.videojs(video.id).pause();
      }
    });
  }
};
